import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface AdvancedPhysicsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const AdvancedPhysicsSection: React.FC<AdvancedPhysicsSectionProps> = ({ config, setConfig }) => (
  <>
    <SectionLabel icon="fa-microchip" darkMode={config.darkMode}>Advanced Physics Engine</SectionLabel>
    <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-neutral-500/5 border-neutral-500/10 mb-4">
      <SmartInput label="Substeps" min={1} max={20} value={config.physicsSubsteps} onChange={v => setConfig(p => ({...p, physicsSubsteps: v}))} darkMode={config.darkMode} />
      <SmartInput label="Air Resistance" min={0.9} max={1.0} step={0.001} value={config.airResistance} onChange={v => setConfig(p => ({...p, airResistance: v}))} darkMode={config.darkMode} />
      <SmartInput label="Max Velocity" min={5} max={100} value={config.maxVelocityLimit} onChange={v => setConfig(p => ({...p, maxVelocityLimit: v}))} darkMode={config.darkMode} />
      <SmartInput label="Min Velocity" min={0} max={20} value={config.minVelocityLimit} onChange={v => setConfig(p => ({...p, minVelocityLimit: v}))} darkMode={config.darkMode} />
      <SmartInput label="Anti-Stall Force" min={0} max={10} step={0.1} value={config.antiStallMultiplier} onChange={v => setConfig(p => ({...p, antiStallMultiplier: v}))} darkMode={config.darkMode} />
    </div>
  </>
);